/* Liquid/HTML usage

  Stagger:
  <parent data-animation="stagger-fade-in" data-animation-duration="1500" data-animation-delay="0" data-animation-stagger="150">
    <child class="animation-child"></child>
  </parent>

  Standalone animation:
  <parent data-animation="fade-in" data-animation-duration="1500" data-animation-delay="0">
*/

class CAnimation {
  constructor (container) {
    this.$container = container
    this.animation = this.$container.dataset.animation
    // Animation delay in milliseconds
    this.animationDelay = this.$container.dataset.animationDelay
    this.animationDelay = this.animationDelay
      ? parseInt(this.animationDelay)
      : 0
    // Animation duration in milliseconds
    this.animationDuration = this.$container.dataset.animationDuration
    this.animationDuration = this.animationDuration
      ? parseInt(this.animationDuration)
      : 0
    // Stagger delay between each child
    this.animationStagger = this.$container.dataset.animationStagger
    this.animationStagger = this.animationStagger
      ? parseInt(this.animationStagger)
      : 0

    // Treshold to set starting point of animation
    this.animationTreshold = this.$container.dataset.animationTreshold
    this.animationTreshold = this.animationTreshold
      ? parseFloat(this.animationTreshold)
      : 0.25

    switch (this.animation) {
      case 'stagger-fade-in':
        this.staggerFadeIn()
        break
      case 'fade-in':
        this.fadeIn()
        break
      case 'image-in':
        this.imageIn()
        break
      default:
        console.warn('Unhandled animation:', this.animation)
    }
  }

  staggerFadeIn () {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Only want this to run once
            this.observer.unobserve(entry.target)

            // Run animations on children
            const children = Array.from(
              this.$container.querySelectorAll('.animation-child')
            )
            for (let i = 0; i < children.length; i++) {
              // Check we're not kidnapping the child of another parent
              const child = children[i]
              if (child.closest('[data-animation]') === this.$container) {
                // Delay before starting animation + stagger delay between each child
                const delay = this.animationDelay + i * this.animationStagger

                setTimeout(() => {
                  child.classList.add('animate-fade-in')
                  child.style.animationDuration = `${this.animationDuration}ms`
                  child.style.opacity = 1

                  // Remove animation to avoid clobbering other animations
                  setTimeout(() => {
                    child.classList.remove('animate-fade-in')
                  }, this.animationDuration + 100) // + 100ms to ensure animation is complete
                }, delay)
              }
            }
          }
        })
      },
      {
        threshold: this.animationTreshold,
        root: null
      }
    )

    this.observer.observe(this.$container)
  }

  fadeIn () {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Only want this to run once
            this.observer.unobserve(entry.target)

            // Delay before starting animation + stagger delay between each child
            const delay = parseInt(this.animationDelay)

            setTimeout(() => {
              this.$container.classList.add('animate-fade-in')
              this.$container.style.animationDuration = `${this.animationDuration}ms`
              this.$container.style.opacity = 1

              // Remove animation to avoid clobbering other animations
              setTimeout(() => {
                this.$container.classList.remove('animate-fade-in')
              }, this.animationDuration + 100) // + 100ms to ensure animation is complete
            }, delay)
          }
        })
      },
      {
        threshold: 0.25,
        root: null
      }
    )

    this.observer.observe(this.$container)
  }

  imageIn () {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Only want this to run once
            this.observer.unobserve(entry.target)

            // Delay before starting animation + stagger delay between each child
            const delay = parseInt(this.animationDelay)

            setTimeout(() => {
              this.$container.classList.add('animate-image-in')
              this.$container.style.animationDuration = `${this.animationDuration}ms`
              this.$container.style.filter = 'brightness(1)'
              this.$container.style.transform = 'scale(1)'

              // Remove animation to avoid clobbering other animations
              setTimeout(() => {
                this.$container.classList.remove('animate-image-in')
              }, this.animationDuration + 100) // + 100ms to ensure animation is complete
            }, delay)
          }
        })
      },
      {
        threshold: 0.25,
        root: null
      }
    )

    this.observer.observe(this.$container)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-animation]')
    .forEach(el => new CAnimation(el))
})
